export const DAY_CHECKLIST = 'DAY_CHECKLIST';
export const WEEK_CHECKLIST = 'WEEK_CHECKLIST';
export const MONTH_CHECKLIST = 'MONTH_CHECKLIST';

export const DAY_WEEK_EVENT = 'DAY_WEEK_EVENT';
export const EVENT_TIME_SLOT = 'EVENT_TIME_SLOT';
export const MONTH_EVENT = 'MONTH_EVENT';
export const WEEK_EVENT = 'WEEK_EVENT';
export const STICKER_DROP = 'STICKER_DROP';
export const HABIT = 'HABIT';
